export const BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS = 'BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS';
export const RECEIVE_SYMPHONY_SEARCH_COMPONENTS = 'RECEIVE_SYMPHONY_SEARCH_COMPONENTS';
export const FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR = 'FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR';
